// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.builder-shell {
  display: grid;
  gap: 1.5rem;
  padding: 0.5rem 0;
}
.builder-shell > header {
  padding: 1.25rem 1.5rem;
  background: #f4f7fa;
  border: 1px solid #dce4eb;
  border-left: 4px solid #0073e6;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.builder-shell h1,
.builder-shell h2 {
  margin: 0;
  line-height: 1.2;
}
.builder-shell h1 {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1a2a38;
  letter-spacing: -0.01em;
}
.builder-shell h2 {
  font-size: 1.2rem;
  font-weight: 700;
}
.builder-shell p {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #56636f;
}

form {
  display: grid;
  gap: 1.25rem;
}

.meta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 1rem;
}
.meta-grid label {
  display: grid;
  gap: 0.45rem;
}
.meta-grid label span {
  font-size: 0.85rem;
  line-height: 1.3;
  font-weight: 600;
  color: #445260;
}
.meta-grid .wide {
  grid-column: 1/-1;
}

input,
textarea,
select,
button,
a {
  border: 1px solid #c7d2da;
  border-radius: 4px;
  min-height: 2.6rem;
  padding: 0.5rem 0.65rem;
  font-size: 0.92rem;
  line-height: 1.35;
  background: #fff;
}

textarea {
  min-height: 5.5rem;
  resize: vertical;
}

a {
  text-decoration: none;
}

.split {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  gap: 1rem;
}
.split article {
  border: 1px solid #d4dde2;
  border-radius: 8px;
  background: #fff;
  padding: 1rem;
  display: grid;
  gap: 0.9rem;
}

.section-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.7rem;
}
.section-head button {
  min-height: 2.5rem;
  padding: 0.45rem 0.8rem;
  font-weight: 600;
}

.field-list,
.section-list {
  display: grid;
  gap: 0.85rem;
}

.field-card {
  border: 1px solid #d8e1e7;
  border-radius: 6px;
  padding: 0.8rem;
  display: grid;
  gap: 0.75rem;
}

.field-row {
  display: grid;
  grid-template-columns: minmax(140px, 1.5fr) minmax(120px, 1fr) repeat(6, auto);
  gap: 0.55rem;
  align-items: center;
}
.field-row .check {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  border: 1px solid #c7d2da;
  border-radius: 4px;
  min-height: 2.3rem;
  padding: 0.4rem 0.5rem;
  white-space: nowrap;
  font-size: 0.84rem;
  line-height: 1.2;
}

.rules-editor {
  display: grid;
  gap: 0.7rem;
  border-top: 1px dashed #d8e1e7;
  padding-top: 0.7rem;
}

.rules-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.7rem;
}
.rules-head h3 {
  margin: 0;
  font-size: 0.98rem;
  line-height: 1.3;
  color: #445059;
}

.hint {
  margin: 0;
  font-size: 0.84rem;
  line-height: 1.5;
  color: #78848d;
}
.hint code {
  background: #eef2f4;
  border-radius: 3px;
  padding: 0.05rem 0.3rem;
}

.rule-card {
  border: 1px solid #e2e9ed;
  border-radius: 5px;
  padding: 0.7rem;
  display: grid;
  gap: 0.6rem;
  background: #fbfcfd;
}

.rule-row {
  display: grid;
  grid-template-columns: 1.4fr 1fr auto;
  gap: 0.65rem;
  align-items: end;
}
.rule-row label {
  display: grid;
  gap: 0.4rem;
  font-size: 0.84rem;
  line-height: 1.35;
  color: #56636f;
}

.actions-editor {
  display: grid;
  gap: 0.5rem;
}

.action-row {
  display: grid;
  grid-template-columns: 140px 1fr auto;
  gap: 0.55rem;
  align-items: center;
}

.section-card {
  border: 1px solid #d8e1e7;
  border-radius: 6px;
  padding: 0.75rem;
  display: grid;
  gap: 0.7rem;
}

.section-row {
  display: grid;
  grid-template-columns: 1fr 80px auto;
  gap: 0.55rem;
}

.section-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0.45rem;
}
.section-fields label {
  display: flex;
  min-height: 2.2rem;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.86rem;
  line-height: 1.35;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
.actions button {
  border: 0;
  color: #fff;
  background: #0f6075;
  cursor: pointer;
  min-height: 2.6rem;
  padding: 0.5rem 1rem;
  font-weight: 600;
}
.actions a {
  min-height: 2.6rem;
  padding: 0.5rem 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.danger {
  border-color: #d3a2a2;
  color: #8a1f1f;
}

.invalid-feedback {
  font-size: 0.84rem;
  line-height: 1.45;
  margin-top: 0.25rem;
}

@media (max-width: 1100px) {
  .field-row {
    grid-template-columns: minmax(150px, 1.3fr) minmax(120px, 1fr) repeat(3, auto);
  }
}
@media (max-width: 920px) {
  .field-row,
  .rule-row,
  .action-row,
  .section-row {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
  .rules-head,
  .section-head {
    flex-direction: column;
    align-items: stretch;
  }
  .actions {
    flex-direction: column;
    align-items: stretch;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tools/dynamic-forms/dynamic-form-builder-page/dynamic-form-builder-page.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AACF;AACE;EACE,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;AAEE;;EAEE,SAAA;EACA,gBAAA;AAAJ;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AADJ;AAIE;EACE,iBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAHJ;;AAOA;EACE,aAAA;EACA,YAAA;AAJF;;AAOA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAJF;AAME;EACE,aAAA;EACA,YAAA;AAJJ;AAMI;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAJN;AAQE;EACE,iBAAA;AANJ;;AAUA;;;;;EAKE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAPF;AASE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;AAPJ;;AAWA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AARF;AAUE;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;AARJ;;AAYA;;EAEE,aAAA;EACA,YAAA;AATF;;AAYA;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;AATF;;AAYA;EACE,aAAA;EACA,8EAAA;EACA,YAAA;EACA,mBAAA;AATF;AAWE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AATJ;;AAaA;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAVF;AAYE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAVJ;;AAcA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAXF;AAaE;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;AAXJ;;AAeA;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AAZF;;AAeA;EACE,aAAA;EACA,qCAAA;EACA,YAAA;EACA,gBAAA;AAZF;AAcE;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,WAAA;AAbF;;AAgBA;EACE,aAAA;EACA,qCAAA;EACA,YAAA;EACA,mBAAA;AAbF;;AAiBA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;AAdF;;AAiBA;EACE,aAAA;EACA,oCAAA;EACA,YAAA;AAdF;;AAiBA;EACE,aAAA;EACA,2DAAA;EACA,YAAA;AAdF;AAgBE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;AAfF;AAiBE;EACE,SAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAhBJ;;AAoBA;EACE,qBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE;IACE,8EAAA;EAjBF;AACF;AAoBA;EACE;;;;IAIE,0BAAA;IACA,oBAAA;EAlBF;EAqBA;;IAEE,sBAAA;IACA,oBAAA;EAnBF;EAsBA;IACE,sBAAA;IACA,oBAAA;EApBF;AACF","sourcesContent":[".builder-shell {\n  display: grid;\n  gap: 1.5rem;\n  padding: 0.5rem 0;\n\n  > header {\n    padding: 1.25rem 1.5rem;\n    background: #f4f7fa;\n    border: 1px solid #dce4eb;\n    border-left: 4px solid #0073e6;\n    border-radius: 6px;\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n  }\n\n  h1,\n  h2 {\n    margin: 0;\n    line-height: 1.2;\n  }\n\n  h1 {\n    font-size: 1.6rem;\n    font-weight: 700;\n    color: #1a2a38;\n    letter-spacing: -0.01em;\n  }\n\n  h2 {\n    font-size: 1.2rem;\n    font-weight: 700;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.9rem;\n    line-height: 1.5;\n    color: #56636f;\n  }\n}\n\nform {\n  display: grid;\n  gap: 1.25rem;\n}\n\n.meta-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));\n  gap: 1rem;\n\n  label {\n    display: grid;\n    gap: 0.45rem;\n\n    span {\n      font-size: 0.85rem;\n      line-height: 1.3;\n      font-weight: 600;\n      color: #445260;\n    }\n  }\n\n  .wide {\n    grid-column: 1 / -1;\n  }\n}\n\ninput,\ntextarea,\nselect,\nbutton,\na {\n  border: 1px solid #c7d2da;\n  border-radius: 4px;\n  min-height: 2.6rem;\n  padding: 0.5rem 0.65rem;\n  font-size: 0.92rem;\n  line-height: 1.35;\n  background: #fff;\n}\n\ntextarea {\n  min-height: 5.5rem;\n  resize: vertical;\n}\n\na {\n  text-decoration: none;\n}\n\n.split {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));\n  gap: 1rem;\n\n  article {\n    border: 1px solid #d4dde2;\n    border-radius: 8px;\n    background: #fff;\n    padding: 1rem;\n    display: grid;\n    gap: 0.9rem;\n  }\n}\n\n.section-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.7rem;\n\n  button {\n    min-height: 2.5rem;\n    padding: 0.45rem 0.8rem;\n    font-weight: 600;\n  }\n}\n\n.field-list,\n.section-list {\n  display: grid;\n  gap: 0.85rem;\n}\n\n.field-card {\n  border: 1px solid #d8e1e7;\n  border-radius: 6px;\n  padding: 0.8rem;\n  display: grid;\n  gap: 0.75rem;\n}\n\n.field-row {\n  display: grid;\n  grid-template-columns: minmax(140px, 1.5fr) minmax(120px, 1fr) repeat(6, auto);\n  gap: 0.55rem;\n  align-items: center;\n\n  .check {\n    display: flex;\n    align-items: center;\n    gap: 0.35rem;\n    border: 1px solid #c7d2da;\n    border-radius: 4px;\n    min-height: 2.3rem;\n    padding: 0.4rem 0.5rem;\n    white-space: nowrap;\n    font-size: 0.84rem;\n    line-height: 1.2;\n  }\n}\n\n.rules-editor {\n  display: grid;\n  gap: 0.7rem;\n  border-top: 1px dashed #d8e1e7;\n  padding-top: 0.7rem;\n}\n\n.rules-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.7rem;\n\n  h3 {\n    margin: 0;\n    font-size: 0.98rem;\n    line-height: 1.3;\n    color: #445059;\n  }\n}\n\n.hint {\n  margin: 0;\n  font-size: 0.84rem;\n  line-height: 1.5;\n  color: #78848d;\n\n  code {\n    background: #eef2f4;\n    border-radius: 3px;\n    padding: 0.05rem 0.3rem;\n  }\n}\n\n.rule-card {\n  border: 1px solid #e2e9ed;\n  border-radius: 5px;\n  padding: 0.7rem;\n  display: grid;\n  gap: 0.6rem;\n  background: #fbfcfd;\n}\n\n.rule-row {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr auto;\n  gap: 0.65rem;\n  align-items: end;\n\n  label {\n    display: grid;\n    gap: 0.4rem;\n    font-size: 0.84rem;\n    line-height: 1.35;\n    color: #56636f;\n  }\n}\n\n.actions-editor {\n  display: grid;\n  gap: 0.5rem;\n}\n\n.action-row {\n  display: grid;\n  grid-template-columns: 140px 1fr auto;\n  gap: 0.55rem;\n  align-items: center;\n}\n\n\n.section-card {\n  border: 1px solid #d8e1e7;\n  border-radius: 6px;\n  padding: 0.75rem;\n  display: grid;\n  gap: 0.7rem;\n}\n\n.section-row {\n  display: grid;\n  grid-template-columns: 1fr 80px auto;\n  gap: 0.55rem;\n}\n\n.section-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 0.45rem;\n\n  label {\n    display: flex;\n    min-height: 2.2rem;\n    align-items: center;\n    gap: 0.35rem;\n    font-size: 0.86rem;\n    line-height: 1.35;\n  }\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n\n  button {\n    border: 0;\n    color: #fff;\n    background: #0f6075;\n    cursor: pointer;\n    min-height: 2.6rem;\n    padding: 0.5rem 1rem;\n    font-weight: 600;\n  }\n\n  a {\n    min-height: 2.6rem;\n    padding: 0.5rem 1rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n  }\n}\n\n.danger {\n  border-color: #d3a2a2;\n  color: #8a1f1f;\n}\n\n.invalid-feedback {\n  font-size: 0.84rem;\n  line-height: 1.45;\n  margin-top: 0.25rem;\n}\n\n@media (max-width: 1100px) {\n  .field-row {\n    grid-template-columns: minmax(150px, 1.3fr) minmax(120px, 1fr) repeat(3, auto);\n  }\n}\n\n@media (max-width: 920px) {\n  .field-row,\n  .rule-row,\n  .action-row,\n  .section-row {\n    grid-template-columns: 1fr;\n    align-items: stretch;\n  }\n\n  .rules-head,\n  .section-head {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
